var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeteor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128 128",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506 1194 c-203 -49 -372 -220 -421 -425 -75 -320 146 -644 473 -691 309 -45 600 172 644 480 57 396 -308 730 -696 636z m154 -59 c0 -26 -27 -71 -54 -89 -48 -31 -141 -12 -166 33 -14 28 -15 28 38 45 66 21 81 24 135 25 36 1 47 -3 47 -14z m207 -40 c169 -84 283 -266 283 -455 0 -57 -22 -167 -41 -202 l-11 -20 -21 20 c-48 45 -124 54 -185 23 -46 -23 -67 -46 -87 -94 -21 -51 -19 -86 10 -142 13 -27 22 -52 19 -56 -7 -13 -140 -39 -196 -39 -326 1 -575 320 -493 633 29 111 104 226 184 281 l42 29 31 -38 c93 -113 267 -76 310 66 11 40 13 41 47 35 20 -3 68 -21 108 -41z m161 -695 c17 -11 32 -28 32 -38 0 -20 -78 -107 -121 -136 -33 -21 -53 -13 -73 29 -19 39 -20 52 -5 94 23 64 104 89 167 51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 915 c-110 -38 -138 -177 -50 -254 87 -76 214 -36 245 78 30 113 -82 214 -195 176z m109 -74 c66 -57 21 -161 -69 -161 -37 0 -85 50 -85 88 0 33 32 80 64 92 26 10 65 2 90 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 841 c-26 -23 -33 -36 -33 -69 0 -46 17 -70 62 -88 82 -35 162 58 117 134 -34 58 -96 68 -146 23z m92 -46 c23 -28 -9 -72 -45 -59 -36 14 -24 74 15 74 10 0 23 -7 30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 530 c-70 -43 -92 -128 -49 -191 30 -46 81 -71 131 -65 138 17 169 195 45 258 -45 23 -86 23 -127 -2z m107 -50 c10 -5 24 -23 31 -40 27 -65 -35 -127 -100 -100 -17 7 -35 21 -40 31 -37 69 40 146 109 109z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeteor);
export default __webpack_public_path__ + "static/media/meteor.f89ba8008411adb5d57d01588d745c3f.svg";
export { ForwardRef as ReactComponent };